module.exports = __webpack_public_path__ + "img/s2_icon_2.53d921c6.png";